import React from 'react';
import { useStore } from '../useStore'; 
import { Department, User } from '../../types';

export const useEmployees = () => {
  const { availableUsers, addEmployee, removeEmployee, updateEmployee } = useStore();

  return {
    getDepartmentEmployees: (department: Department) => 
      availableUsers.filter(emp => emp.department === department),
    addEmployee,
    removeEmployee,
    updateEmployee,
    getAllEmployees: () => {
      return availableUsers;
    }
  };
};